import React, { FC } from "react";
import { Doughnut } from "react-chartjs-2";
import styled from "styled-components";
import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
//import "chartjs-plugin-doughnutlabel";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "chart.js";

//import { useDashboardData } from "../../../Hooks/useDashboard";
//import LoadingIndicator from "../../LoadingIndicator/index";
import "./dashboard.scss";
import { StuntTypeProp } from "../../../CustomTypes/Filters";
import { useHookForApi } from "../../../Hooks/useHookForApi";
import { errorToast } from "../../../Utils/toastMessage";
import CustomToast from "../../CustomToast/CustomToast";
import { consolelog } from "../../../Utils/consolelog";

Chart.register(ChartDataLabels);

const ChartWarapper = styled.div`
  max-width: auto;
  margin: 0 auto;
`;
const Journey: FC<StuntTypeProp> = (stuntType) => {
  const onSuccess = (data: any) => {
    consolelog("onSuccess callback", data);
    if (data.isAxiosError && data.name === 'Error' && data.message === "Network Error") {
      errorToast(JSON.stringify(`Unable to connect with Journey service and possible reason is: (${data})`));
    }
  };
  const onError = (error: any) => {
    //console.clear();
  };

  //purchaseorders/dashboard
  const {
    isLoading: isDataLoading,
    data: response,
    isFetching,
    //} = useDashboardData(onSuccess, onError, `transportplans/dashboard${stuntType.stuntType}`);
  } = useHookForApi(onSuccess, onError, 0, 0, `transportplans/dashboard${stuntType.stuntType}`);

  const labels = ["Picked", "Shipped", "Hold"];
  const dataForCalulation = [response?.data?.picked, response?.data?.shipped, response?.data?.hold];
  const customLabels = labels.map((label, index) => `${response?.data?.totalCount}`);

  const dashboardData = {
    labels: customLabels,
    datasets: [
      {
        data: dataForCalulation,
        backgroundColor: [
          "rgba(230, 128, 48, 1)",
          "rgba(234, 166, 60, 1)",
          "rgba(87, 183, 114, 1)",
          "rgba(73, 149, 238, 1)",
        ],
        borderColor: [
          "rgba(230, 128, 48, 1)",
          "rgba(234, 166, 60, 1)",
          "rgba(87, 183, 114, 1)",
          "rgba(73, 149, 238, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    rotation: -90,
    circumference: 180,
    responsive: true,
    cutoutPercentage: 75,
    plugins: {
      ChartDataLabels,
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: (value: any, ctx: any) => {
          let sum = 0;
          const dataArr = ctx.chart.data.datasets[0].data;
          sum = dataArr.reduce((prev: any, cur: any) => prev + cur);
          const percentage = ((value * 100) / sum).toFixed(2) + "%";
          if (percentage === "NaN%" || percentage === "0.00%") {
            return "";
          }
          return percentage;
        },
      },
      tooltips: {
        callbacks: {
          // label: function (context: any) {
          //   let label = context.dataset.label || '';
          //   if (label) {
          //     label += ': ';
          //   }
          //   if (context.parsed.y !== null) {
          //     label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
          //   }
          //   return label;
          // }
          // label: function (tooltipItem: any, data: any) {
          //   var dataset = data.datasets[tooltipItem.datasetIndex];
          //   var total = dataset.data.reduce(function (previousValue: any, currentValue: any, currentIndex: any, array: any) {
          //     return previousValue + currentValue;
          //   });
          //   var currentValue = dataset.data[tooltipItem.index];
          //   var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
          //   return percentage + "%";
          // }
        },
      },
    },
    animation: {
      animateScale: true,
      animateRotate: true,
    },
  };

  // const calculatePercentage = (total: number, currentValue: number) => {
  //   return Math.floor(((currentValue / total) * 100) + 0.5);
  // }
  //{"picked":12,"shipped":8,"hold":1,"shippedTomorrow":1,"totalCount":21}
  return (
    <>
      <div className="ln-u-soft colour">
        <GridWrapper equalHeight>
          {/* <GridItem size="1/2">
            <p className="property">Number of Journey {data?.totalCount}</p>
          </GridItem> */}

          <GridItem size="1/2">
            <div className="property">Number of Journey
              <h2 className="shippedTomorrowValue">{response?.data?.totalCount}</h2></div>
          </GridItem>
          <GridItem size="1/2">
            <div className="property">Ship Tomorrow
              <h2 className="shippedTomorrowValue">{response?.data?.shippedTomorrow}</h2></div>
          </GridItem>
        </GridWrapper>

        <GridWrapper equalHeight>
          <GridItem size="1/2">
            <ChartWarapper>
              <Doughnut data={dashboardData} options={options} />
            </ChartWarapper>
          </GridItem>
          <GridItem size="1/2">
            {/* <div>Shipped Tomorrow<h2 className="shippedTomorrowValue">{data?.shippedTomorrow}</h2></div> */}

            <div className="" style={{ position: 'relative' }}>
              <div className="journeyPosition">
                <div className="parent">
                </div>
                <div className="parent">
                  Picked ({response?.data?.picked}) &nbsp;
                  <div className="child picked"></div>
                </div>
                <div className="parent">
                  Shipped ({response?.data?.shipped}) &nbsp;
                  <div className="child shipped"></div>
                </div>
                <div className="parent">
                  Hold ({response?.data?.hold}) &nbsp;
                  <div className="child hold"></div>
                </div>
              </div>

            </div>
          </GridItem>
        </GridWrapper>
      </div>
      <CustomToast />
    </>
  );
};

export default Journey;
